export const locationsData = [
    /* {
        "name": "lindavista",
        "url": "lindavista",
        "type": "Terrenos",
        "position": "top",
        "shape": "poly",
        "coords": "3954.82 3213.44 3760.32 3213.44 3760.32 3278.99 3954.82 3278.99 3954.82 3221.5 3954.82 3213.44",
        "pin":"M3863.4,3133.42c-16.59,0-30.09,12-30.09,26.67,0,5.92,4.27,15.57,13,29.51,6.21,9.86,12.32,18.08,12.57,18.43l4.48,6,4.47-6c.25-.35,6.36-8.57,12.57-18.43,8.77-13.94,13-23.59,13-29.51C3893.48,3145.38,3880,3133.42,3863.4,3133.42Zm0,40.31c-8.62,0-15.6-6.19-15.6-13.82s7-13.83,15.6-13.83,15.59,6.19,15.59,13.83S3872,3173.73,3863.4,3173.73Z"
    }, */
    {
        "name": "senderos",
        "url": "senderos",
        "type": "Terrenos",
        "position": "top",
        "shape": "poly",
        "coords": "2556.51 2967.86 2445.83 2967.86 2430.44 2967.86 2430.44 3070.35 2556.51 3070.35 2556.51 2967.86",
        "pin":"M2494.74,2888.19c-16.59,0-30.09,12-30.09,26.67,0,5.92,4.27,15.57,13,29.51,6.21,9.86,12.32,18.08,12.57,18.43l4.48,6,4.47-6c.25-.35,6.36-8.57,12.57-18.43,8.77-13.94,13-23.59,13-29.51C2524.82,2900.15,2511.32,2888.19,2494.74,2888.19Zm0,40.31c-8.62,0-15.6-6.19-15.6-13.82s7-13.83,15.6-13.83,15.59,6.19,15.59,13.83S2503.35,2928.5,2494.74,2928.5Z"
    },
    {
        "name": "alamos",
        "url": "alamos",
        "type": "Terrenos",
        "position": "top",
        "shape": "poly",
        "coords": "3610.04 1950.23 3451.82 1950.23 3444.09 1950.23 3444.09 2034.93 3610.04 2034.93 3610.04 1950.23",
        "pin":"M3533.67,1870.9c-16.59,0-30.09,12-30.09,26.67,0,5.92,4.27,15.58,13.05,29.52,6.21,9.86,12.31,18.08,12.57,18.42l4.47,6,4.47-6c.26-.34,6.37-8.56,12.57-18.42,8.78-13.94,13.05-23.6,13.05-29.52C3563.76,1882.87,3550.26,1870.9,3533.67,1870.9Zm0,40.31c-8.61,0-15.59-6.19-15.59-13.82s7-13.82,15.59-13.82,15.6,6.18,15.6,13.82S3542.28,1911.21,3533.67,1911.21Z"
    },
    {
        "name": "canadas",
        "url": "canadas_casas",
        "type": "casas",
        "shape": "poly",
        "position": "top",
        "coords": "1424.68 630.07 1289.81 630.07 1286.05 630.07 1286.05 745.47 1424.68 745.47 1424.68 630.07",
        "pin":"M1357.6,550.41c-16.59,0-30.09,12-30.09,26.67,0,5.92,4.27,15.58,13,29.52,6.21,9.85,12.31,18.08,12.57,18.42l4.47,6,4.47-6c.26-.34,6.37-8.56,12.57-18.42,8.78-13.94,13-23.6,13-29.52C1387.69,562.37,1374.19,550.41,1357.6,550.41Zm0,40.31c-8.61,0-15.6-6.19-15.6-13.82s7-13.82,15.6-13.82,15.6,6.18,15.6,13.82S1366.21,590.72,1357.6,590.72Z"
    },
    {
        "name": "canadas",
        "url": "canadas_terrenos",
        "type": "Terrenos",
        "shape": "poly",
        "position": "left",

    },
    {
        "name": "canadas",
        "url": "canadas_deptos",
        "type": "Departamentos",
        "shape": "poly",
        "position": "right",
    },
    {
        "name": "vallenorte",
        "type": "Terrenos",
        "url": "vallenorte",
        "position": "top",
        "shape": "poly",
        "coords": "806.29 461.11 638.5 461.11 629.08 461.11 629.08 564.75 806.29 564.75 806.29 461.11",
        "pin":"M720.3,380.66c-16.59,0-30.09,12-30.09,26.67,0,5.92,4.27,15.58,13,29.52,6.21,9.86,12.32,18.08,12.57,18.42l4.48,6,4.47-6c.25-.34,6.36-8.56,12.57-18.42,8.77-13.94,13-23.6,13-29.52C750.38,392.63,736.88,380.66,720.3,380.66Zm0,40.31c-8.62,0-15.6-6.19-15.6-13.82s7-13.82,15.6-13.82,15.59,6.19,15.59,13.82S728.91,421,720.3,421Z"
    },
    {
        "name": "vallesur",
        "url": "vallesur",
        "type": "Terrenos",
        "position": "top",
        "shape": "poly",
        "coords": "1088.02 636.71 920.23 636.71 910.81 636.71 910.81 740.34 1088.02 740.34 1088.02 636.71",
        "pin":"M1002.57,557.31c-16.59,0-30.08,12-30.08,26.67,0,5.92,4.26,15.58,13,29.52,6.21,9.86,12.31,18.08,12.57,18.42l4.47,6,4.47-6c.26-.34,6.37-8.56,12.57-18.42,8.78-13.94,13.05-23.6,13.05-29.52C1032.66,569.28,1019.16,557.31,1002.57,557.31Zm0,40.31c-8.61,0-15.59-6.19-15.59-13.82S994,570,1002.57,570s15.6,6.19,15.6,13.82S1011.19,597.62,1002.57,597.62Z"
    },
    {
        "name": "paseodelparque",
        "url": "paseodelparque",
        "type": "Terrenos",
        "position": "top",
        "shape": "poly",
        "coords": "997.39 1823.1 992.55 1823.1 845.07 1823.1 845.07 1935.2 997.39 1935.2 997.39 1823.1",
        "pin":"M981.55,1742.45c-16.59,0-30.09,12-30.09,26.67,0,5.92,4.27,15.58,13,29.52,6.2,9.85,12.31,18.08,12.57,18.42l4.47,6,4.47-6c.26-.34,6.36-8.57,12.57-18.42,8.78-13.94,13-23.6,13-29.52C1011.63,1754.41,998.14,1742.45,981.55,1742.45Zm0,40.31c-8.61,0-15.6-6.19-15.6-13.82s7-13.82,15.6-13.82,15.59,6.18,15.59,13.82S990.16,1782.76,981.55,1782.76Z"
    },
    /* {
        "name": "encinos",
        "url": "encinos",
        "type": "Terrenos",
        "position": "top",
        "shape": "poly",
        "coords": "2468.45 2470.18 2309.96 2468.76 2302.85 2468.76 2302.85 2538.77 2468.45 2540.19 2468.45 2470.18918.5,879.6 915.5,897.1 918.5,909.5 986.5,909.5 983.9,879.6",
        "pin":"M2391.31,2336.29c-27.26,0-49.44,19.65-49.44,43.81,0,9.74,7,25.6,21.43,48.51,10.21,16.2,20.24,29.71,20.66,30.27l7.35,9.88,7.35-9.88c.42-.56,10.45-14.07,20.65-30.27,14.43-22.91,21.44-38.77,21.44-48.51C2440.75,2355.94,2418.57,2336.29,2391.31,2336.29Zm0,66.23c-14.15,0-25.63-10.17-25.63-22.71s11.48-22.71,25.63-22.71,25.63,10.16,25.63,22.71S2405.46,2402.52,2391.31,2402.52Z"
    }, */
    {
        "name": "TPDP",
        "url": "torrespaseodelparque",
        "type": "Departamentos",
        "position": "top",
        "shape": "poly",
        "coords": "948.04 1737.84 939.33 1737.84 750.22 1737.84 750.22 1791.09 948.04 1791.09 948.04 1737.84",
        "pin":"M811.89,1658.48c-16.59,0-30.08,12-30.08,26.67,0,5.92,4.26,15.58,13,29.52,6.21,9.86,12.31,18.08,12.57,18.42l4.47,6,4.47-6c.26-.34,6.37-8.56,12.58-18.42,8.77-13.94,13-23.6,13-29.52C842,1670.45,828.48,1658.48,811.89,1658.48Zm0,40.31c-8.61,0-15.59-6.19-15.59-13.82s7-13.82,15.59-13.82,15.6,6.18,15.6,13.82S820.51,1698.79,811.89,1698.79Z"
    },
    {
        "name": "lomalta",
        "url": "lomalta",
        "type": "Terrenos",
        "position": "top",
        "shape": "poly",
        "coords": "785.34 988.09 675.23 988.09 660.85 988.09 660.85 1104.77 785.34 1104.77 785.34 988.09",
        "pin":"M775.92,907.87c-16.59,0-30.09,12-30.09,26.66,0,5.93,4.27,15.58,13,29.52,6.21,9.86,12.32,18.08,12.57,18.43l4.48,6,4.47-6c.26-.35,6.36-8.57,12.57-18.43,8.78-13.94,13-23.59,13-29.52C806,919.83,792.51,907.87,775.92,907.87Zm0,40.31c-8.62,0-15.6-6.19-15.6-13.83s7-13.82,15.6-13.82,15.59,6.19,15.59,13.82S784.53,948.18,775.92,948.18Z"
    },
    {
        "name": "ciudadsalud",
        "url": "ciudadsalud",
        "type": "Terrenos",
        "position": "top",
        "shape": "poly",
        "coords": "767.43 796.56 560.04 796.56 540.74 796.56 540.74 925.91 767.43 925.91 767.43 796.56",
        "pin":"M659.08,716.8c-16.59,0-30.09,12-30.09,26.67,0,5.92,4.27,15.58,13,29.52,6.21,9.86,12.31,18.08,12.57,18.42l4.47,6,4.47-6c.26-.34,6.37-8.56,12.57-18.42,8.78-13.94,13-23.6,13-29.52C689.17,728.77,675.67,716.8,659.08,716.8Zm0,40.31c-8.61,0-15.6-6.19-15.6-13.82s7-13.82,15.6-13.82,15.6,6.18,15.6,13.82S667.69,757.11,659.08,757.11Z"
    },
    {
        "name": "clubdegolf",
        "url": "clubdegolf",
        "type": "Terrenos",
        "position": "top",
        "shape": "poly",
        "coords": "2038.3 1760.87 1886.09 1760.87 1886.09 1919.22 2038.3 1919.22 2038.3 1768.33 2038.3 1760.87",
        "pin":"M1963.67,1681.2c-16.59,0-30.09,12-30.09,26.67,0,5.92,4.27,15.58,13,29.52,6.21,9.86,12.32,18.08,12.57,18.42l4.48,6,4.47-6c.25-.34,6.36-8.56,12.57-18.42,8.77-13.94,13-23.6,13-29.52C1993.75,1693.17,1980.25,1681.2,1963.67,1681.2Zm0,40.31c-8.62,0-15.6-6.19-15.6-13.82s7-13.82,15.6-13.82,15.59,6.19,15.59,13.82S1972.28,1721.51,1963.67,1721.51Z"
    },
    {
        "name": "torreaireaplus",
        "url": "torreaireaplus",
        "type": "Departamentos",
        "position": "top",
        "shape": "poly",
        "coords": "3457.74 2437.17 3353.3 2437.17 3345.38 2437.17 3345.38 2494.38 3457.74 2494.38 3457.74 2437.17",
        "pin":"M3435.35,2357c-16.59,0-30.08,12-30.08,26.67,0,5.92,4.26,15.57,13,29.51,6.21,9.86,12.31,18.08,12.57,18.43l4.47,6,4.48-6c.25-.35,6.36-8.57,12.57-18.43,8.77-13.94,13-23.59,13-29.51C3465.44,2369,3451.94,2357,3435.35,2357Zm0,40.31c-8.61,0-15.59-6.19-15.59-13.82s7-13.83,15.59-13.83,15.6,6.19,15.6,13.83S3444,2397.31,3435.35,2397.31Z"
    },
    {
        "name": "bosques",
        "url": "bosques",
        "type": "Casas",
        "position": "top",
        "shape": "poly",
        "coords" :"1473.35 907.73 1373.68 907.73 1363.71 907.73 1363.71 1045.18 1473.35 1045.18 1473.35 907.73",
        "pin":"M1422.91,827.94c-16.59,0-30.08,12-30.08,26.67,0,5.92,4.26,15.58,13,29.52,6.21,9.86,12.31,18.08,12.57,18.42l4.47,6,4.47-6c.26-.34,6.37-8.56,12.57-18.42,8.78-13.94,13-23.6,13-29.52C1453,839.91,1439.5,827.94,1422.91,827.94Zm0,40.31c-8.61,0-15.59-6.19-15.59-13.82s7-13.82,15.59-13.82,15.6,6.19,15.6,13.82S1431.52,868.25,1422.91,868.25Z"
    },
    /* {
        "name": "vistahermosa",
        "url": "https://torrevistahermosamorelia.com/",
        "type": "sitio web",
        "position": "top",
        "shape": "poly",
        "coords": "3540.09 3685.1 3386.86 3685.1 3374.72 3685.1 3374.72 3811.15 3540.09 3811.15 3540.09 3685.1",
        "pin":"M3460.81,3603c-16.59,0-30.08,12-30.08,26.67,0,5.92,4.26,15.57,13,29.51,6.21,9.86,12.31,18.08,12.57,18.43l4.47,6,4.48-6c.25-.35,6.36-8.57,12.57-18.43,8.77-13.94,13-23.59,13-29.51C3490.9,3615,3477.4,3603,3460.81,3603Zm0,40.31c-8.61,0-15.59-6.19-15.59-13.82s7-13.83,15.59-13.83,15.6,6.19,15.6,13.83S3469.43,3643.31,3460.81,3643.31Z"
    }, */
    {
        "name": "pradosur",
        "url":  "pradosur",
        "type": "Terrenos",
        "position": "top",
        "shape": "poly",
        "coords":"2075.31 2875.31 1913.36 2875.31 1903.7 2875.31 1903.7 2949.89 2075.31 2949.89 2075.31 2875.31",
        "pin":"M1994.23,2794.09c-16.59,0-30.09,12-30.09,26.66,0,5.93,4.27,15.58,13,29.52,6.21,9.86,12.32,18.08,12.57,18.43l4.48,6,4.47-6c.25-.35,6.36-8.57,12.57-18.43,8.77-13.94,13-23.59,13-29.52C2024.31,2806.05,2010.81,2794.09,1994.23,2794.09Zm0,40.31c-8.62,0-15.6-6.19-15.6-13.83s7-13.82,15.6-13.82,15.59,6.19,15.59,13.82S2002.84,2834.4,1994.23,2834.4Z"
    }

]
